import type { ViewProps } from 'react-native-svg/lib/typescript/fabric/utils'
import { View } from 'react-native'
import { Body } from '~/components/typography/Content.tsx'
import { Heading1, Heading2 } from '~/components/typography/Titles.tsx'
import { cn } from '~/lib/utils.ts'

export const ViewTitle = ({ children, className, ...props }: ViewProps) => {
  return (
    <View className={cn('px-4', className)} {...props}>
      <Heading1 className="text-center">{children}</Heading1>
    </View>
  )
}

export const SectionTitle = ({
  children,
  className,
  textClassName,
  ...props
}: { textClassName?: string } & ViewProps) => {
  return (
    <View className={cn('px-4', className)} {...props}>
      <Heading2 className={cn('text-center', textClassName)}>{children}</Heading2>
    </View>
  )
}

export const SectionContent = ({
  children,
  className,
  textClassName,
  ...props
}: ViewProps & { textClassName?: string }) => {
  return (
    <View className={cn(className)} {...props}>
      <Body className={cn('text-pretty text-center text-base/relaxed', textClassName)}>
        {children}
      </Body>
    </View>
  )
}
